import Grid from '@mui/material/Grid';
import * as React from 'react';
import * as Redux from 'react-redux';
import ActExtraEstudiantesView from '../../actextra_estudiantes/ActExtraEstudiantesView';
import InfoActividadExtra from './components/InfoActividadExtra';

const PanelActividadExtraView = () => {
  const actividadesExtrasStore = Redux.useSelector(
    (state) => state.actividadesExtras,
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={3}>
        <InfoActividadExtra activo={actividadesExtrasStore.activo} />
      </Grid>
      <Grid item xs={12} md={9}>
        <ActExtraEstudiantesView />
      </Grid>
    </Grid>
  );
};

export default PanelActividadExtraView;
